import { apiKeyClient } from "@better-auth/api-key/client";
import { dodopaymentsClient } from "@dodopayments/better-auth/client";
import { adminClient, anonymousClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  fetchOptions: {
    credentials: "include",
  },
  plugins: [adminClient(), anonymousClient(), dodopaymentsClient(), apiKeyClient()],
});
